import type { HealthStatus } from '../api/types'
import { STATUS_BG, STATUS_COLOR, STATUS_GLYPH, STATUS_LABEL } from '../theme/charts'

/**
 * Status is always glyph + word + colour, never colour alone.
 *
 * Two of the four status colours sit below 3:1 contrast on the light surface,
 * and roughly one reader in twelve cannot separate the red from the green at
 * all — so the shape and the word are what actually carry the meaning here.
 */
export function StatusChip({ status, showLabel = true }: {
  status: HealthStatus
  showLabel?: boolean
}) {
  return (
    <span
      className="status-chip"
      style={{ background: STATUS_BG[status], color: STATUS_COLOR[status] }}
      title={STATUS_LABEL[status]}
    >
      <span className="glyph" aria-hidden="true">{STATUS_GLYPH[status]}</span>
      {showLabel && <span>{STATUS_LABEL[status]}</span>}
      {!showLabel && <span className="sr-only">{STATUS_LABEL[status]}</span>}
    </span>
  )
}
